<div
  class="max-md:bg-white/90 max-md:backdrop-blur max-md:border-b max-md:border-b-slate-200 flex gap-1 h-14 lg:px-2 items-center z-20 md:pointer-events-none">
  <a appearance="flat" class="pointer-events-auto !w-fit" queryParamsHandling="merge" size="s" tuiButton>
    <img alt="logo" class="h-full" src="https://cdn.pixacare.com/logo/left-transparent.svg" />
  </a>

  <div class="ml-auto flex items-center gap-1">
    <pxc-locale-picker-dropdown />

    <div class="ml-auto pointer-events-auto" [tuiDropdown]="helpMenuActions" [(tuiDropdownOpen)]="helpMenuOpen">
      <button appearance="flat" aria-label="Help" iconStart="@tui.circle-help" tuiIconButton></button>
    </div>
  </div>
</div>

<ng-template #helpMenuActions>
  <pxc-menu-actions [actions]="helpActions" />
</ng-template>
